import { NewProductI } from "../../../api/request/Lead/Interfaces/ProductInterface.response";

export const isMockUpsell = (): boolean => {
  if (typeof window === "undefined") return false;
  // Hard block in production — preview/sandbox affordance must never reach real users.
  if (process.env.REACT_APP_ENVIROMENT === "PRD") return false;
  return new URLSearchParams(window.location.search).get("mock") === "1";
};

const today = new Date();
const effectDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000)
  .toISOString()
  .slice(0, 10);

export const upsellMockProduct: NewProductI = {
  birthdate: "1985-04-12",
  phone: "+39 333 1234567",
  gender: "M",
  zipcode: "00100",
  email: "mario.rossi@example.it",
  finalYearlyPrice: 240,
  regularPrice: 24,
  priceToPay: 20,
  isPromoted: true,
  beforePromoText: "Invece di",
  afterPromoText: "€/mese",
  effectDate,
  capital: 150000,
  minCapital: 25000,
  maxCapital: 500000,
  coverage: "basic",
  upgraded: false,
  upgradedCapital: 0,
  downgraded: 0,
  downgradedCapitalMaximum: 0,
  extraCapitalAmount: 10000,
  extraCapitalPrice: 2,
  extraDisabilityCost: 5,
  period: "monthly",
  ipaAvailable: true,
  availableTraits: { DEATH: true, DISABILITY: true },
  capitalsByTrait: { DEATH: 150000 },
  traitBoundaries: [
    { trait: "DEATH", available: true, min: 25000, max: 500000 },
    { trait: "DISABILITY", available: true, min: 25000, max: 500000 },
  ],
  globalAccumulatedMax: 500000,
  externalCapital: 0,
  capitals: {
    DEATH: {
      active: true,
      capital: 150000,
      available: true,
      min: 25000,
      max: 500000,
    },
    DISABILITY: {
      active: false,
      capital: 0,
      available: true,
      min: 25000,
      max: 500000,
    },
  },
  feeCollection: [
    {
      frecuency: "MONTHLY",
      expectedPaymentDate: effectDate,
      total: 20,
      discountAmount: 4,
    },
  ],
  promotion: {
    conditions: "Promo valida fino al 31/12.",
    exceptions: "Non cumulabile con altre offerte.",
    promotionalCode: "10_sconto",
  },
};
